define('common/js/lib/util/loader',[], function () {
  /**
   * Load the given JS src. Does not handle errors
   * @param {string} src
   * @param {{type?: 'module'|'nomodule'; async?: string, defer?: string, crossorigin?: string}} props
   * @param {(event?: Event|string) => void} [callback] on script load, error or already in DOM
   */
  function loadJS(src, props, callback) {
    if (document.querySelector('script[src="' + src + '"]')) {
      // src already in DOM
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }

    var script = document.createElement('script');

    if (props.async === '') {
      script.setAttribute('async', '');
    }

    if (props.defer === '') {
      script.setAttribute('defer', '');
    }

    if (props.type === 'module') {
      script.setAttribute('type', 'module');
    } else if(props.type === 'nomodule') {
      script.setAttribute('nomodule', '')
    }

    script.src = src;
    script.setAttribute('crossorigin', props.crossorigin || 'anonymous');

    if (typeof callback === 'function') {
      script.onload = callback;
      script.onerror = callback;
    }

    document.head.appendChild(script);
  }

  function loadCSS(href, props, callback) {
    // Bail if already in DOM
    if (document.querySelector('link[href="' + href + '"][rel="stylesheet"]')) {
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    // temporarily, set media to something non-matching to ensure it'll fetch without blocking render
    link.media = 'only x';

    function onload() {
      link.media = props.media || 'all';
      if (typeof callback === 'function') {
        callback();
      }
    }
    link.onload = onload;
    link.onerror = onload;

    document.head.appendChild(link);
  }

  return {
    loadJS: loadJS,
    loadCSS: loadCSS
  };
});
